import Instagram from '../../../styles/staticAssets/images/Instagram.svg';
import Facebook from '../../../styles/staticAssets/images/Facebook.svg';
import Twitter from '../../../styles/staticAssets/images/Twitter.svg';
import GoogleMapLocation from '../../../styles/staticAssets/images/GoogleMapLocation.svg';
import apple from '../../../styles/staticAssets/images/apple.svg';
import GoogleplayIcon from '../../../styles/staticAssets/images/GoogleplayIcon.svg';
const FOOTER_DATA = {
  contentData: {
    bodyContent: {
      kfcLogo: {
        src: '',
        alt: '',
      },
      categories: [
        {
          categoryHeaderText: 'KFC Food',
          subCategories: [
            {
              name: 'Menu',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Catering',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Neutrition',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Order Lookup',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Gift Card',
              linkTo: '',
              targetType: 'self',
            },
          ],
        },
        {
          categoryHeaderText: 'Support',
          subCategories: [
            {
              name: 'Help',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'FAQs',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Contact Us',
              linkTo: '',
              targetType: 'self',
            },
          ],
        },
        {
          categoryHeaderText: 'Legal',
          subCategories: [
            {
              name: 'Privacy Policy',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Terms of Use',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Our Ads',
              linkTo: '',
              targetType: 'self',
            },
            {
              name: 'Do Not Sell My Personal Installation',
              linkTo: '',
              targetType: 'self',
            },
          ],
        },
      ],
      kfcStoreSearch: {
        name: 'findKfc',
        linkTo: '',
        url: GoogleMapLocation,
        alt: '',
      },
      downloadAppButtons: [
        {
          name: 'Apple Store',
          linkTo: '',
          url: apple,
        },
        {
          name: 'Google Play',
          linkTo: '',
          url: GoogleplayIcon,
        },
      ],
    },
    footerContent: {
      languageDropdown: {
        name: 'Eng',
        linkTo: '',
        url: '',
        type: 'Language Selector',
        options: ['Eng', 'Fr', 'De'],
      },
      copyrightContentData: {
        name: 'Copyright © KFC Corporation 2020 All Rights Reserved',
      },
      socialMediaContent: [
        {
          name: 'Instagram',
          linkTo: '',
          url: Instagram,
          alt: '',
        },
        {
          name: 'Facebook',
          linkTo: '',
          url: Facebook,
          alt: '',
        },
        {
          name: 'Twitter',
          linkTo: '',
          url: Twitter,
          alt: '',
        },
      ],
    },
  },
};

export default FOOTER_DATA;
